module.exports = __webpack_public_path__ + "static/media/skila-bg_img-02-1-nad_600px_width-0_1.10cf0822.png";